import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appTreelistCustomCell]'
})
export class TreelistCustomCellDirective {
  @Input('appTreelistCustomCell') columnName: string;
  constructor(public template: TemplateRef<any>) {}
}